import podcastImg from '@epi-assets/images/Edenred-EMP-banner-Etumatkalla-podcast.jpg';
import rewardingImg from '@epi-assets/images/Edenred-EMP-banner-Rewarding-guide.jpg';

interface BannerContent {
  locale: 'en' | 'fi';
  header: string;
  imageAlt: string;
  imageSrc: string;
  link: string;
  linkKind: 'Relative';
  linkText: string;
  text: string;
  linkTwo?: string;
  linkTextTwo?: string;
}

interface Banner {
  content: BannerContent;
  id: number;
  name: string;
  priority: number;
  templateName: 'Banner';
}

export const homeBanner = (
  paymentLimitsImg: string,
  delicardImg: string,
  taxationImg: string
): Banner[] => [
  {
    content: {
      locale: 'en',
      header: 'Employee benefit payment limits',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/en/blog/employee-benefit-payment-limits',
      linkKind: 'Relative',
      linkText: 'Check the payment limits',
      text: "What were the tax-free payment limits this year? You'll find them by clicking the link!"
    },
    id: 1,
    name: 'Payment Limits',
    priority: 1,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Työsuhde-etujen ajankohtaiset maksurajat',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/fi/blog/tyosuhde-etujen-maksurajat',
      linkKind: 'Relative',
      linkText: 'Tarkista maksurajat',
      text: 'Mitä olivatkaan verovapaat maksurajat tänä vuonna? Löydät ne linkin takaa!'
    },
    id: 2,
    name: 'Payment Limits',
    priority: 1,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: "Edenred's podcast: Etumatkalla",
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Explore (in Finnish)',
      text: `Are you looking for a Finnish podcast on HR topics that provides practical tips for people interested in workplace well-being? Edenred's Etumatkalla podcast is made for a better working life!`
    },
    id: 3,
    name: 'Podcast',
    priority: 2,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Edenredin Etumatkalla-podcast',
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Tutustu ja kuuntele',
      text: 'Oletko etsinyt suomenkielistä HR-aiheista podcastia, jossa annetaan käytännönläheisiä vinkkejä työhyvinvoinnista kiinnostuneille? Edenredin Etumatkalla-podcast on tehty parempaa työelämää varten!'
    },
    id: 4,
    name: 'Podcast',
    priority: 2,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Want to learn more about benefit taxation? ',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/en/download-tax-guide?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download tax guide',
      text: 'Clarify employee benefit taxation by downloading our comprehensive and highly popular tax guide.'
    },
    id: 5,
    name: 'Tax guide',
    priority: 3,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Haluatko oppia lisää etujen verotuksesta?',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/fi/lataa-verotusopas?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa verotusopas',
      text: 'Selvennä työsuhde-etujen verotuksen kiemuroita lataamalla kattava ja suuren  suosion  saanut vero-oppaamme.'
    },
    id: 6,
    name: 'Tax guide',
    priority: 3,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Are you looking for tips on tax-free rewarding?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/en/delicard-abcs-of-rewarding?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download rewarding guide',
      text: 'Rewarding employees fosters commitment to the workplace, increases motivation, and improves the employee experience. Do you know how to reward employees tax-free in various situations? Download our guide to find out!'
    },
    id: 7,
    name: 'Rewarding guide',
    priority: 4,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Kaipaatko vinkkejä verovapaaseen palkitsemiseen?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/fi/delicard-palkitsemisen-abc?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa palkitsemisen opas',
      text: 'Työntekijöiden palkitseminen sitouttaa työpaikkaan, lisää motivaatiota, ja parantaa työntekijäkokemusta. Tiedätkö, miten voit palkita henkilöstöä erilaisissa tilanteissa verovapaasti? Lataa oppaamme niin se selviää!'
    },
    id: 8,
    name: 'Rewarding guide',
    priority: 4,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Tax-free recognition on special occasions',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/en/buy-gift-cards?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/en/request-offer?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Order gift cards',
      linkTextTwo: 'Request an offer',
      text: 'Christmas gifts, retirement, anniversaries and birthdays, summer gifts... Delicard® gift cards offer a tax-free option for expressing gratitude and congratulations for every celebration!'
    },
    id: 9,
    name: 'Delicard®',
    priority: 5,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Verovapaata muistamista merkkipäivinä',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/pyyda-tarjous?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Osta lahjakortteja',
      linkTextTwo: 'Kysy tarjous',
      text: 'Joululahja, eläkkeelle siirtyminen, merkki- ja syntymäpäivät, kesälahja... Delicard®-lahjakortit tarjoavat verovapaan vaihtoehdon kiitoksen osoittamiseen ja onnitteluun jokaisessa juhlan aiheessa!'
    },
    id: 10,
    name: 'Delicard®',
    priority: 5,
    templateName: 'Banner'
  }
];
